import { Injectable, signal } from '@angular/core';

import { AdminProfileState } from 'app/services/shared';

// Gives the usergroup domain its own DI token/instance of AdminProfileState,
// isolating it from EventProfileState, PointOfSaleProfileState, and
// UserProfileState. Also holds hash/exists for the currently loaded usergroup
// alongside isAdminProfile — both describe the same "current usergroup profile
// visit" scope, set by the usergroup-role guard/usergroup-profile.ts.
// Do not merge with the other AdminProfileState subclasses.
@Injectable()
export class UsergroupContext extends AdminProfileState {
    private hashSignal = signal<string | null>(null);
    private existsSignal = signal<boolean | null>(null);

    hash = this.hashSignal.asReadonly();
    exists = this.existsSignal.asReadonly();

    setHash(hash: string): void {
        if (hash) this.hashSignal.set(hash);
    }

    setExists(exists: boolean): void {
        this.existsSignal.set(exists);
    }
}
